import { render, staticRenderFns } from "./HrInfo.vue?vue&type=template&id=477e2013&scoped=true&"
import script from "./HrInfo.vue?vue&type=script&lang=js&"
export * from "./HrInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477e2013",
  null
  
)

export default component.exports